import axios from 'axios';
import apiClient from '../utils/apiClient';
import { API_BASE_URL } from '../utils/apiBaseUrl';

const API_URL = '/api/auth';
const USER_API_URL = '/api/users';

const authService = {
  // Register user
  register: async (userData) => {
    const response = await apiClient.post(`${API_URL}/register`, userData);
    return response.data;
  },

  // Login user
  login: async (email, password) => {
    const response = await apiClient.post(`${API_URL}/login`, { email, password });
    return response.data;
  },

  // Logout user
  logout: async () => {
    try {
      await apiClient.post(`${API_URL}/logout`);
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  // This function is no longer needed as we verify through getUserProfile
  
  // Get user profile - separate function to fetch user data
  getUserProfile: async () => {
    const response = await apiClient.get(`${USER_API_URL}/profile`);
    return response.data.user;
  },

  // Update user profile
  updateProfile: async (userData) => {
    const response = await apiClient.put(`${USER_API_URL}/profile`, userData);
    return response.data.user;
  },

  
  // Toggle newsletter opt-in setting
  toggleNewsletterOptIn: async () => {
    const response = await apiClient.post(`${USER_API_URL}/settings/toggle-newsletter`);
    return response.data;
  },
  
  // Toggle collection privacy setting
  toggleCollectionPrivacy: async () => {
    const response = await apiClient.post(`${USER_API_URL}/settings/toggle-collection-privacy`);
    return response.data;
  },
  
  // Subscribe guest to newsletter
  subscribeGuestToNewsletter: async (email) => {
    // Use regular axios for unauthenticated requests
    const response = await axios.post(`${API_BASE_URL}${USER_API_URL}/guest-newsletter-signup`, { email });
    return response.data;
  },
  
  // Change password
  changePassword: async (currentPassword, newPassword) => {
    const response = await apiClient.post(`${USER_API_URL}/change-password`, {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  // Forgot password
  forgotPassword: async (email) => {
    // Use regular axios for unauthenticated requests
    const response = await axios.post(`${API_BASE_URL}${API_URL}/forgot-password`, { email });
    return response.data;
  },

  // Reset password
  resetPassword: async (resetToken, newPassword) => {
    // Use regular axios for unauthenticated requests
    const response = await axios.post(`${API_BASE_URL}${API_URL}/reset-password`, {
      resetToken,
      newPassword
    });
    return response.data;
  }
};

export default authService;